export const API = {
  __REST_API_URL: "https://api.fouassin-gmao.fr/dci",
  __SOCKET_URL: "https://api.fouassin-gmao.fr",
  __SOCKET_PATH: "/dci/socket.io",
};



// WEBPACK FOOTER //
// ./src/config/Api.ts